import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { appStyles } from '../App.styles';
;
/**
 * BrandVoices element
 * @param props Brand voices props
 * @returns Brand Voices element
 */
export const BrandVoicesSubtitle = function (props) {
    // Get translation
    const { t, i18n } = useTranslation();
    const { sx } = props;
    return (_jsxs(Box, Object.assign({ sx: Object.assign({ display: 'flex', color: '#082018', boxShadow: 'none', textTransform: 'none', backgroundColor: '#CEE9DD', borderRadius: '8px', padding: '1rem' }, sx) }, { children: [_jsx(ErrorOutlineOutlinedIcon, {}), _jsx(Typography, Object.assign({ sx: Object.assign(Object.assign({}, appStyles.text14), { textAlign: 'left', color: '#000000', marginLeft: '0.5rem', marginTop: '0.1rem' }) }, { children: t('Add Brand Voices to enable AI writing in a specific, consistent style that connects with your target audience.') }))] })));
};
